export default "__VITE_ASSET__bXVWGjHe__"